import { always, cond, T } from 'ramda';

import { isCrossword, isExtendedTest, isTest } from './test';

export const getAnswersMaxLength = cond([
  [isTest, always(12)],
  [isExtendedTest, always(12)],
  [isCrossword, always(0)],
  [T, always(10)],
]);
